export var ScrollDirection;
(function (ScrollDirection) {
    ScrollDirection[ScrollDirection["LEFT"] = -1] = "LEFT";
    ScrollDirection[ScrollDirection["RIGHT"] = 1] = "RIGHT";
})(ScrollDirection || (ScrollDirection = {}));
